<template>
  <div class="security-information">
    <div class="description">
      <div class="title">כדי לבנות לך תזרים חודשי המערכת צריכה גישה מאובטחת לחשבונות הבנק והאשראי שלך</div>
      <div class="image-wrapper">
        <img class="safe-image" :src="require('@/assets/onboarding/safe2.svg')"/>
      </div>
    </div>
    <div class="information-security">
      <div class="content-bullet" v-for="(content, index) in securityBulletsContent" :key="index">
        <div class="circle-wrapper">
            <img class="check" :src="require('@/assets/onboarding/icons/check-blue.svg')">
        </div>
        <div class="security-bullet-title">{{ content.line1 }}</div>
        <div class="security-bullet-description">{{ content.line2 }}</div>
        <div class="security-bullet-description">{{ content.line3 }}</div>
      </div>
    </div>
    <div class="trust-section">
      <div class="bold">אנחנו עושים הכל כדי לשמור על המידע שלך</div>
      <div class="logo-wrapper">
        <img class="logos" :src="require('@/assets/onboarding/trust-logos.svg')"/>
      </div>
    </div>
    <div class="footer">
      <single-click-button class="button" :size="'small'" title="לחיבור החשבונות" :action="confirm"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Segment from '../../../../../Segment';
import SingleClickButton from '../../../../../base-components/SingleClickButton';

const securityBullets = [
  { line1: 'למערכת יש גישה לקריאת הנתונים בלבד', line2: 'לא נבצע שום פעולות', line3: 'בחשבון הבנק שלך' },
  { line1: 'הכסף שלך מוגן בכל מצב ', line2: 'יש לך איתנו ביטוח אחריות', line3: 'מקצועית של חברת AIG' },
  { line1: 'אנחנו מאגר מידע רשום', line2: 'בפיקוח הרשות לניירות ערך', line3: 'והרשות להגנת הפרטיות' },
  { line1: 'לא נבקש פרטי אשראי מלאים ותעודת זהות', line2: 'למערכת אין יכולת לבצע', line3: 'פעולות בשמך' },
];

export default {
  name: 'SecurityInformation',
  components: {
    SingleClickButton,
  },
  async created() {
    Segment.trackUserGot('SecurityPage_PageEntered');
    Segment.trackUserGot('SecurityPage_PageEntered_Marketing');
  },
  computed: {
    securityBulletsContent() {
      return securityBullets;
    },
  },
  methods: {
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    confirm() {
      Segment.trackUserInteraction('SecurityPage_NextClicked');
      Segment.trackUserInteraction('SecurityPage_NextClicked_Marketing');
      this.onboardingPageSubmit();
    },
    videoPlayed() {
      Segment.trackUserInteraction('SecurityPage_PlayClicked');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

.security-information {

  .description {
    background-color: $riseup_light_blue;
    padding: 40px 30px 70px;

    .title {
      font-size: 24px;
      line-height: 32px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .image-wrapper {
      text-align: center;

      .safe-image {
        margin-right: 8%;
      }
    }
  }

  .information-security {
    text-align: center;
    padding-bottom: 75px;

    .content-bullet {
      width: 100%;
      padding: 75px 30px 0;

      .security-bullet-title {
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        padding: 15px 0 10px;
      }

      .security-bullet-description {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }

  .trust-section {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    padding: 50px 20px 20px;

    .bold {
      padding-bottom: 50px;
    }
  }

  .footer {
    background-color: $riseup_white;
    position: sticky;
    bottom: 0;
    display: flex;
    padding: 30px;

    .riseup-button {
      width: 100%;
      height: 75px;
    }
  }
}
</style>
